module.exports = __webpack_public_path__ + "img/logo-jys.86268a29.png";